import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Caret from '../assets/Caret';
import VymoLogo from '../assets/VymoLogo';
import Button from '../Button/Button';
import './Header.scss';

const Links = [
  {
    key: 'nav-l-1',
    title: 'AI',
    multiple: true,
    target: '_self',
    Submenu: [
      { 
        id: 1,
        title: 'Cognitive AI',
        url: '/cognitive-ai/',
        subhead: 'Unlock Advanced Capabilities with Cognitive AI',
        icon: 'cognitive-ai-icon1.webp',
      },
      { 
        id: 2,
        title: 'Deep Learning',
        url: '/deep-learning/',
        subhead: 'Harnessing Deep Learning for Smarter Insights',
        icon: 'deep-learning-icon1.webp',
      },
      { 
        id: 3,
        title: 'Machine Learning',
        url: '/machine-learning/',
        subhead: 'Empowering Success withMachine Learning',
        icon: 'cognitive-ai-icon3.webp',
      },
    ],  
  },
  {
    key: 'nav-l-2',
    title: 'Products',
    multiple: true,
    target: '_self',
    Submenu: [
      { 
        id: 1,
        title: 'OnboardIQ',
        url: '/onboardiq/',
        subhead: 'A Complete End-To-End Solution for Producer Recruitment',
        icon: 'icon4.svg',
      },
      { 
        id: 2,
        title: 'EngageIQ',
        url: '/engageiq-overview/',
        subhead: 'Unlock significant organizational sales growth',
        icon: 'icon3.svg',
        children: [
          {
            id: 2.1,
            title: 'EngageIQ for Leaders',
            url: '/engageiq-for-leaders/',
            subhead: 'AI Performance Insights',
            icon: 'icon9.svg',
          },
          {
            id: 2.2,
            title: 'EngageIQ for Sellers',
            url: '/engageiq-for-sellers/',
            subhead: 'Drive Sales Results',
            icon: 'icon9.svg',
          },
        ],
      },
    ],  
  },
  {
    key: 'nav-l-3',
    title: 'Channel',
    multiple: true,
    target: '_self',
    Submenu: [
      { 
        id: 1,
        title: 'Captive Agents',
        url: '/captive-agents/',
        subhead: 'Insurance Carrier',
        icon: 'icon7.svg',
      },
      {
        id: 2,
        title: 'Independent Agents',
        url: '/independent-agents/',
        subhead: 'Insurance Carrier',
        icon: 'icon10.svg',
      },
      {
        id: 3,
        title: 'Distributors',
        url: '/distributors/',
        subhead: 'MGAs, IMOs, Wholesalers, and Agencies',
        icon: 'icon2.svg',
      },
    ],
  },
  {
    key: 'nav-l-4',
    title: 'Persona',
    multiple: true,
    target: '_self',
    Submenu: [
      { 
        id: 1,
        title: 'Agency Relationship Managers',
        url: '/vymo-for-agency-relationship-managers/',
        subhead: 'Optimize Recruiting and Performance',
        icon: 'ageny-icon1.webp',
      },
      {
        id: 2,
        title: 'Producers',
        url: '/vymo-for-producers/',
        subhead: 'Accelerate Success and Drive Engagement',
        icon: 'producer-icon1.webp',
      },
      {
        id: 3,
        title: 'Sales Leaders',
        url: '/vymo-for-sales-leaders/',
        subhead: 'Empower Leaders Across All Channels',
        icon: 'sales-leaders-icon3.webp',
      },
      {
        id: 4,
        title: 'HR Leaders',
        url: '/vymo-for-hr-leaders/',
        subhead: 'Transform Onboarding and Engagement',
        icon: 'hr-icon1.webp',
      },
    ],
  },
  {
    key: 'nav-l-5',
    title: 'Company',
    multiple: true,
    target: '_self',
    Submenu: [
      { 
        id: 1,
        title: 'Customers',
        url: '/customers/',
        subhead: 'Trusted by Leading Financial Institutions.',
        icon: 'icon11.svg',
      },
      { 
        id: 2,
        title: 'About Us',
        url: '/aboutus/',
        subhead: 'Learn about our journey.',
        icon: 'icon15.svg',
      },
    ],  
  },
  {
    key: 'nav-l-6',
    url: 'https://vymo.com/us/resources/',
    title: 'Resources',
    multiple: false,
    target: '_self',
  },
];

function Header({ dark }) {
  const [openNav, setOpenNav] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isScrollingUp, setIsScrollingUp] = useState(false);

  const navOpenTrigger = () => {
    setOpenNav((state) => !state);
  };

  // Detect scroll direction
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const currentScrollY = window.scrollY;

  //     if (currentScrollY < lastScrollY && currentScrollY > 220) {
  //       setIsScrollingUp(true); // Scrolling up
  //     } else {
  //       setIsScrollingUp(false); // Scrolling down
  //     }

  //     setLastScrollY(currentScrollY);
  //   };

  //   window.addEventListener('scroll', handleScroll);
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, [lastScrollY]);

  // Resize listener for nav close
  useEffect(() => {
    const resizeListener = () => {
      const width = window.innerWidth || 1280;
      if (width >= 1280 && openNav) {
        setOpenNav(false);
      }
    };

    window.addEventListener('resize', resizeListener);
    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  }, [openNav]);

  return (
    <header>
      <div
        className={`header-main ${isScrollingUp ? 'sticky' : ''} ${
          !dark ? 'light' : ''
        }`}
      >
        <div className="fluid-container">
          <div
            className={`flex flex-row pt-[8px] justify-between items-center header-container ${
              openNav ? 'show' : ''
            }`}
          >
            <Link to="https://vymo.com/us/" onClick={() => {window.location.href="https://vymo.com/us/"}} style={{ zIndex: 1 }} className="logo">
              <VymoLogo dark={openNav && !dark ? true : dark} />
            </Link>
            <ul className={`nav-list ${openNav ? 'show' : ''}`}>
              {Links.map((l) => (
                <Link
                  to={l.url}
                  key={l.key}
                  onClick={() => {window.location.href = l.url}}
                  target={l.target}
                  className={`flex flex-col md:flex-row md:items-center text-[15px] font-medium w-full font-secondary lg-menu-parent ${
                    l.multiple && 'nav-multiple'
                  }`} >
                  <div className="flex flex-row items-center justify-between md:justify-start lg-menu-child">
                    <span className={`inline-block ${l.multiple && 'mr-1'}`}>
                      {l.title}
                    </span>
                    {l.multiple && <Caret />}
                  </div>
                  {l.multiple === true && (
                      <ul 
                        className={`dropdown-menu lg-menu !static md:!absolute hidden md:grid ${l.Submenu.length > 4 ? 'grid-cols-1 md:grid-cols-2 xl-menu w-full' : ''}`}>
                        {l.Submenu.map((sl) => ( 
                          <li key={`${sl.title}-${sl.id}`} className="dropdown-header">
                            <Link to={sl.url} className="!flex gap-[16px] items-center !mb-1 md:mb-0 cursor-pointer">
                              <img src={`/img/dms/icons/nav/${sl.icon}`} alt={`${sl.title} icon`} className="w-[28px] md:w-[30px]"/>
                              <div className="flex flex-wrap flex-col">
                                <span className="leading-[18px] md:leading-[28px] text-14 font-medium">{sl.title}</span>
                                <span className="text-[12px] leading-[18px] font-medium pt-[3px] md:pt-[1px] text-[#706f6c] font-secondary">
                                  {sl.subhead}
                                </span>
                              </div>
                            </Link>
                            {sl.children && (
                            <ul className="sub-dropdown grid grid-cols-2">
                              {sl.children.map((child) => (
                                <li key={child.id} className="sub-dropdown-header !pt-0 p-1 md:p-1 gap-2 ml-1 md:ml-0 mt-1 md:mt-0">
                                  <Link to={child.url} className="dropdown-link !bg-[#f8f8f8]">
                                    <img src={`/img/dms/icons/nav/${child.icon}`} alt={child.title} className="icon w-[30px]"/>
                                    <div className="mt-1">
                                      <span className="text-[13px] font-medium">{child.title}</span>
                                      <span className="subhead text-[12px] mt-[3px] opacity-60 block leading-[18px]">{child.subhead}</span>
                                    </div>
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                          </li>
                        ))}
                      </ul>
                    )}
                </Link>
              ))}
              <Link
                to="/request-demo/" onClick={() => {window.location.href="/request-demo/"}}
                className="flex items-center text-[15px] font-medium false lg:hidden xl:hidden mt-1">
                <Button className="header-action">Book a Demo</Button>
              </Link>
            </ul>
            <Link to="/request-demo/">
              <Button className="header-action hidden">Book a Demo</Button>
            </Link>
            <button
              onClick={navOpenTrigger}
              className={`hamburger inline-flex lg:hidden xl:hidden justify-center items-end flex-col w-5 h-5 relative z-50 ${
                openNav ? 'nav-open' : ''
              }`}
              type="button"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

Header.propTypes = {
  dark: PropTypes.bool,
};
Header.defaultProps = {
  dark: true,
};

export default Header;